import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import View from './View';
import { receiveAuth } from '../../modules/user/actions';

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      receiveAuth
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./src/routes/TermsPage/index.js